import { Response } from '@/types/Common';
import axios from '../request';

export default {
  /**
   * @param {string} path
   * @return {Promise<Response<any>>}
   */
  getCascaderData: async (typeClass = 0) => {
    const res = await axios.get(`/Api/DataType/getCategories?type_class=${typeClass}`);
    return res.data;
  },
  rename: async (typeId, typeName) => {
    const res = await axios.post(`/Api/DataType/rename`, {
      type_id: typeId,
      type_name: typeName,
    });
    return res.data;
  },
  add: async (body) => {
    const res = await axios.post(`/Api/DataType/add`, body);
    return res.data;
  },
  delete: async (typeId) => {
    const res = await axios.post(`/Api/DataType/delete`, {
      type_id: typeId,
    });
    return res.data;
  },
};
